module.exports = __webpack_public_path__ + "img/portfolio-02-670x479.8e2f943e.jpg";